module.exports = __webpack_public_path__ + "9e2b1ed274616269497485e15b812096.MP3";